import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import { Fields as Merchant } from 'models/Merchant'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'

const t = buildTranslate('thanx_campaigns.performance')
const tError = buildTranslate('errors')

interface EmailEngagementOverviewProps {
  userIsAdmin: boolean
  merchant: Merchant
  emailEngagementOverviewPath: string
  emailEngagementOverviewHeight: number
  titleKey?: string
}

const EmailEngagementOverview: React.FC<EmailEngagementOverviewProps> = ({
  userIsAdmin,
  merchant,
  emailEngagementOverviewPath,
  emailEngagementOverviewHeight,
  titleKey = 'emailEngagement.title',
}) => {
  const [css] = useStyletron()

  return (
    <div className="pb-l grey-05-bkg">
      <div className="container pl-0 pr-0">
        <Container
          className={`px-0 ${css({
            minHeight: `${emailEngagementOverviewHeight + 300}px`,
          })}`}
        >
          <Switch
            condition={userIsAdmin}
            fallback={
              <Text.BodyText3 className="mb-xl">
                {tError('forbidden_title')}
              </Text.BodyText3>
            }
          >
            <LookerIframe
              path={emailEngagementOverviewPath}
              merchant={merchant}
              height={`${emailEngagementOverviewHeight}px`}
              title={t(titleKey)}
            />
            <LookerFooter className="my-xl" />
          </Switch>
        </Container>
      </div>
    </div>
  )
}

export default EmailEngagementOverview
